import { AnyAction } from 'redux';
import { Vertragsschlussverfahren } from '@ps20/bff-models';
import {
  GlobalAction,
  GlobalActions,
  isMaklerbetreuerOrMaklerOrUvm,
  isVertriebstelefonie,
  RoleDeterminedPayload
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { CheckoutActions } from '../checkout.actions';

export const vertragsschlussverfahrenReducer = function(
  sectionState: Vertragsschlussverfahren = null,
  action: AnyAction
): Vertragsschlussverfahren {
  switch (action.type) {
    case CheckoutActions.VERTRAGSSCHLUSSVERFAHREN_CHANGED: {
      return action.payload.vertragsschlussverfahren;
    }
    case GlobalActions.ROLE_DETERMINED: {
      const globalAction: GlobalAction<RoleDeterminedPayload> = action;
      if (isMaklerbetreuerOrMaklerOrUvm(globalAction.payload.role)) {
        return Vertragsschlussverfahren.KUNDENANTRAG;
      } else if (isVertriebstelefonie(globalAction.payload.role)) {
        return Vertragsschlussverfahren.TELEFONVERKAUF;
      } else {
        return sectionState;
      }
    }
    case GlobalActions.NAVIGATION_COMPLETED: {
      const isCheckout = action.payload.appId === App.SHOP_CHECKOUT;

      if (isCheckout) {
        return Vertragsschlussverfahren.KUNDENANTRAG;
      }

      return sectionState;
    }
    case GlobalActions.ADD_PRODUKT_TO_ANGEBOTE: {
      if (
        action.payload.appId === App.UNF &&
        sectionState === Vertragsschlussverfahren.TELEFONVERKAUF
      ) {
        return null;
      } else {
        return sectionState;
      }
    }
    default:
      return sectionState;
  }
};
